// eslint-disable-next-line no-restricted-imports -- the one wrapper everything else goes through
import loadable from '@loadable/component';

import LoadingPage from 'my-components/LoadingPage';

const RETRY_ATTEMPTS = 3;
const RETRY_DELAY_MS = 1500;

export default function Loadable(loader, { fallback, hideLoader } = {}) {
  // Track the resolved module in a closure so that subsequent mounts of this Loadable can
  // load synchronously via `requireSync` / `isReady`. Without this, `@loadable/component`
  // re-enters the async path on every mount (since we don't use `@loadable/babel-plugin`),
  // which causes a fallback flash and — under rapid navigation — can leave the component
  // stuck on the fallback when the post-mount setState races with an unmount.
  let resolvedModule = null;
  return loadable(
    {
      requireAsync: () =>
        retryLoaderPromise(loader, RETRY_ATTEMPTS).then(mod => {
          resolvedModule = mod;
          return mod;
        }),
      requireSync: () => resolvedModule,
      isReady: () => !!resolvedModule,
      resolve: () => undefined,
      chunkName: () => undefined,
    },
    { fallback: fallback || (hideLoader ? null : <LoadingPage />) },
  );
}

function retryLoaderPromise(loader, attemptsLeft) {
  return new Promise((resolve, reject) => {
    loader().then(resolve, error => {
      if (attemptsLeft <= 1) {
        reject(error);
        return;
      }
      setTimeout(() => {
        retryLoaderPromise(loader, attemptsLeft - 1).then(resolve, reject);
      }, RETRY_DELAY_MS);
    });
  });
}
